// extracted by mini-css-extract-plugin
export default {"tag":"HubSFAssociationStatus_tag__ifBOD","tag-break":"HubSFAssociationStatus_tag-break__ymbjm"};